import React, { useEffect, useState, useRef } from 'react';
import Breadcrumb from '../../../components/common/breadcrumb';
import { Advance, URL_Start } from '../../../constant';
import { Container, Row, Col, Card, Form, Button } from 'react-bootstrap';
import DataTables from '../commonComponent/DataTable/DataTables';
import NoRecordFounds from '../commonComponent/DataTable/NoRecordFounds';
import axios from 'axios';
import SweetAlert from 'sweetalert2';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { CSVLink } from "react-csv";
import * as XLSX from 'xlsx';
import InputGroup from 'react-bootstrap/InputGroup';
import { MultiSelect } from 'react-multi-select-component';
import '../../../pages/admin/react-multiselect.css';
import Select from 'react-select';
import moment from 'moment';
import { saveAs } from 'file-saver';
import { Spinner } from 'react-bootstrap';
const AdvanceCollection = () => {
    let fromDate = useRef();
    let toDate = useRef();
    let CurrentDateTime = moment()
    .format('YYYY_MM_DD|hh_mm_ss_a');
    let CurrentDateUSe = moment()
      .format('YYYY-MM-DD');
      let CurrentMonthUse = moment()
      .format('MMMM-YYYY');
      let TodayUse = moment()
      .format('YYYY_MMM_DD');
    const [downloadvisible, setDownloadVisible] = useState(false);
    const [BusinessDatalistCSV, setBusinessDatalistCSV] = useState([]);
    const[ReportOption,SetReportOption]=useState("1");
    const today = new Date();
    const date = today.setDate(today.getDate());
    const defaultValue = new Date(date).toISOString().split('T')[0] // yyyy-mm-dd
    const [defaultDate, setDefaultDate] = useState(defaultValue);
    const [SelectCentreDDL, SetSelectCentreDDL] = useState([]);
    const [SelectCentres, SetSelectCentres] = useState([]);
    const [LGlCentreTypeoption, SetLGlCentreTypeoption] = useState([]);
    const [SelectCentreTypeDDL, SetSelectCentreTypeDDL] = useState([]);
    const [SelectCentreType, SetSelectCentreType] = useState([]);
    const [LGlSelectCentreTypeoption, SetLGlSelectCentreTypeoption] = useState([]);
    const [SelectDepartmentDDL, SetSelectDepartmentDDL] = useState([]);
    const [SelectDepartment, SetSelectDepartment] = useState([]);
    const [LGlSelectDepartmentTypeoption, SetLGlSelectDepartmentTypeoption] = useState([]);
    const[VisitVal,SetVisitVal]=useState("0");
    const abortControllerRef = useRef(null);
    const [isLoading, setIsLoading] = useState(false);
    useEffect(() => {
        const CentreTypeL = [];
        GetBindCenterAllLists(CentreTypeL);
    }, []);

    
    
  
    const handleSearchList = async () => {
        if(SelectCentres == null || SelectCentres.length == 0)
        {
            SweetAlert.fire({ title: "Warning", text: "client selection is required", icon: "info" });
        }
         else{
           
            let filenameCust="";
           
            let  dateFull='From_'+moment(fromDate.current.value).format('DD_MMM_YYYY')+'_'+'TO_'+moment(toDate).format('DD_MMM_YYYY')+'|Print_'+CurrentDateTime;
               filenameCust= dateFull;
            GetReportData_CSV();
         }
    }
 
  const GetReportData_CSV = async () => {
  try {
    // Create AbortController for request cancellation
    const controller = new AbortController();

    // Keep in ref if you want external cancel tracking
    abortControllerRef.current = controller;

    setIsLoading(true);
    setDownloadVisible(false);

    const ObjServiceCollection = {
      UserId: localStorage.getItem('LoggedInUser'),
      FromDate: fromDate.current.value,
      ToDate: toDate.current.value,
      objtblCentreIds: LGlCentreTypeoption,
      IsExcelD: "1"
    };

    const url = `${URL_Start}reports/DownloadCsvAdvancePaymentReport`;

    console.log("Downloading CSV from:", url);

    const response = await axios.post(url, ObjServiceCollection, {
      responseType: 'blob',
      headers: {
        'Accept': 'text/csv'
      },
      signal: controller.signal // Enables AbortController cancellation
    });

    // Check for successful response and handle blob
    if (response.status === 200) {
      const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });
      saveAs(blob, 'AdvanceCollectionReport.csv');
    } else {
      console.error('Error: Non-200 status code', response.status);
    }

    } catch (error) {
        if (axios.isCancel(error)) {
        console.warn('CSV download was cancelled by user.');
        } else if (error.name === 'CanceledError') {
        console.warn('Request cancelled due to AbortController.');
        } else {
        console.error('Error downloading CSV file:', error);
        }
    } finally {
        setIsLoading(false);
    }
    };
   
      const  GetBindCenterAllLists= async (TypeOptL) => {
        const  ObjFilterCentye={
            CentreFilterType: "2"
        }
        try {
            let url = URL_Start + 'master/getBindAllCentreListsNew'
            await axios.post(url,ObjFilterCentye).then((response) => {
                const data = response.data;
                if (data.Success) {
                    if (data.Data != null) {
                         let ds=data.Data;
                         const TypeOptionDs1 = [];
                        ds.map((option) => {
                            const TypeOptions1 = {
                                'CentreId': option.CentreId,
                                'label': option.CentreName,
                                'value': option.CentreId,
                                'CenterTypeId': option.CenterTypeId,
                                'disabled': false
                            }
                            return TypeOptionDs1.push(TypeOptions1);
                        });
                        SetSelectCentreDDL(TypeOptionDs1); 
                       
                    }
                    else {  SetSelectCentreDDL([]); }
                }
            }).catch(function (error) {
                //ErrorFunction(error.response.status);
                SetSelectCentreDDL([]);
             });
        }
        catch (error) {
            SetSelectCentreDDL([]);
            SweetAlert.fire({ title: "Server Inaccessible!", text: "You may not be connected to a network or Unable to connect to a server", icon: "error" }); }
    }
   
    const CentreHandler = (options) => {

        SetSelectCentres(options);
        const TypeOptL = [];
        if (options != null && options.length > 0) {
            options.map((item) => {
                const TypeOptrows = {
                    'CentreId': item.CentreId
                }
                return TypeOptL.push(TypeOptrows);
            });
          SetLGlCentreTypeoption(TypeOptL);

        }
         else{
            SetLGlCentreTypeoption([]);  
         }
    }
    return (
        <React.Fragment>
            <Breadcrumb title="Advance Collection" parent="Reports" />
            <Container fluid>
                 <Row className='mt25'>
                    <Col md={12}>
                        <Card>
                            <Card.Body>
                            
                                <Form.Row>
                                    <Col md={12}>
                                   <div className='mb-2'><b>Date Filter</b></div>
                                    </Col>
                                </Form.Row>
                             <Form.Row>
                          <Col md={3}>
                              <Form.Group>
                                  <Form.Label>From Date</Form.Label>
                                  <InputGroup className="mb-3 d-flex justify-content-start">
                                      <Form.Control type="date" id="fromDate" name="fromDate" ref={fromDate} defaultValue={defaultDate} />
                                  </InputGroup>
                              </Form.Group>
                          </Col>
                          <Col md={3}>
                              <Form.Group>
                                  <Form.Label>To Date</Form.Label>
                                  <InputGroup className="mb-3 d-flex justify-content-start">
                                      <Form.Control type="date" id="toDate" name="toDate" ref={toDate} defaultValue={defaultDate} />
                                  </InputGroup>
                              </Form.Group>
                          </Col>
                      </Form.Row>
                      <Form.Row>
                                    <Col md={12}>
                                   <div className='mb-2'><b>Centres Detail</b></div>
                                    </Col>
                                </Form.Row>
                                <Form.Row className="justify-content-left">
                                <Col md={5} lg={5}>
                             <Form.Group>
                                <Form.Label>Centre<span className='text-required'>* required</span></Form.Label>
                                <MultiSelect id="CentreSelect" name="CentreSelect"
                                    options={SelectCentreDDL}
                                    value={SelectCentres}
                                    onChange={CentreHandler}
                                    labelledBy="Select"
                                />
                            </Form.Group>
                        </Col>
                        <Col md={4} lg={4}>
                             
                        </Col>  
                          </Form.Row>
                          <Form.Row className="justify-content-left">
                              
                          </Form.Row>
                                <Form.Row>
                                 
                                    <Col md={12} className='text-center __center__buttonsec mb-4 mt25'>
                                        {
                                         isLoading ?
                                        <div className='text-center'> <Spinner animation="border" size='sm' /></div> :
                                        <><Button variant='primary' onClick={handleSearchList} filename={"AdvanceCollection.csv"} target="_blank" >Download CSV</Button>
                                        </>
                                    }
                                    </Col>
                                  
                                </Form.Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row> 
            </Container>
        </React.Fragment>
    )
}

export default AdvanceCollection;